import { render, staticRenderFns } from "./detail_info.vue?vue&type=template&id=709952f4&scoped=true"
import script from "./detail_info.vue?vue&type=script&lang=js"
export * from "./detail_info.vue?vue&type=script&lang=js"
import style0 from "./detail_info.vue?vue&type=style&index=0&id=709952f4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709952f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('709952f4')) {
      api.createRecord('709952f4', component.options)
    } else {
      api.reload('709952f4', component.options)
    }
    module.hot.accept("./detail_info.vue?vue&type=template&id=709952f4&scoped=true", function () {
      api.rerender('709952f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/inventory_detail/components/detail_info.vue"
export default component.exports